// Single frontend home for unit display labels. Handles BOTH vocabularies that
// reach the UI so no surface ever echoes a raw code (Polish-first rule):
//   - lowercase sale-unit / WZ codes ('pcs', 'm2', ...) — mirrors backend
//     unitLabels.js (the document-side source of truth)
//   - the uppercase `ProductUnit` enum ('PIECE', 'SQUARE_METER', ...) stored as
//     a product's baseUnit and carried onto PZ lines.
const UNIT_LABELS: Record<string, string> = {
  // lowercase sale-unit / WZ line codes
  pcs: 'szt.',
  m2: 'm²',
  m3: 'm³',
  kg: 'kg',
  mb: 'mb',
  m: 'm',
  l: 'l',
  // ProductUnit enum (uppercase) — product baseUnit, e.g. on PZ item lines
  PIECE: 'szt.',
  KILOGRAM: 'kg',
  METER: 'm',
  LINEAR_METER: 'mb',
  SQUARE_METER: 'm²',
  CUBIC_METER: 'm³',
  LITER: 'l',
  SET: 'kpl.',
  PACKAGE: 'opak.',
};

export function formatUnit(unit: string | null | undefined): string {
  if (!unit) return 'szt.';
  return UNIT_LABELS[unit] || unit;
}
